module.exports = __webpack_public_path__ + "static/media/ship_broken.25b83267.png";